import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["height", "width"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.is_fomantic)
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass($options.fomantic_class),
        height: $options.c_width,
        width: $options.c_height
      }, null, 10 /* CLASS, PROPS */, _hoisted_1))
    : ($props.external)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({width: $props.width, height: $props.height})
        }, [
          _createElementVNode("img", { src: $options.href_full }, null, 8 /* PROPS */, _hoisted_2)
        ], 4 /* STYLE */))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref: "svgdiv",
          style: _normalizeStyle({width: $options.c_width, height: $options.c_height}),
          class: _normalizeClass({hoverable: $props.hoverable, hover: $props.hover, ['custom-stroke']: !!$props.stroke}),
          "stroke-width": "var(--icon-stroke-width)",
          innerHTML: $data.svg_data
        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_3))
}